import { combineReducers } from "redux";

import reviews from "public/reducers/reviews";
import signup from "public/reducers/signup";

export default combineReducers({
  reviews,
  signup,
});
